export enum AssetTypes {
    CURRENCY = 'Ccy',
    ASSET = 'Security'
}